import { FilterFieldsOptions } from '@ui/ui.module';

export type TypeEnum = 'create' | 'update' | 'delete';
export const TypeEnum = {
  Create: 'create' as TypeEnum,
  Delete: 'delete' as TypeEnum,
  Update: 'update' as TypeEnum,
};

export type AuditClassName =
  'Base' |
  'BeneD' |
  'BeneF' |
  'BeneMI' |
  'BeneOA' |
  'BeneS' |
  'Collezione' |
  'DocumentoArc' |
  'DocumentoBib' |
  'File' |
  'OggettoCollezione' |
  'Persona' |
  'Role' |
  'Session' |
  'User';

export interface Audit {
  id?: string;
  /**
   * Object identifier of the audit resource
   */
  objectId: string;
  user: string;
  type: TypeEnum;
  className: AuditClassName;
  note?: string;
  date: string;
}

export interface AuditFilter {
  className?: AuditClassName;
  date?: Date;
  objectId?: string;
  type?: TypeEnum;
  user?: string;
}

export const AuditsFiltersMeta: FilterFieldsOptions<AuditFilter> = {
  className: { operator: 'equal' },
  date: { operator: 'greater_or_equal', typeField: 'datetime' },
  objectId: { operator: 'equal', typeField: 'oid' },
  type: { operator: 'equal' },
  user: { operator: 'equal', typeField: 'oid' },
};
